import 'jquery-colorbox';
import Responsive from './Responsive';
import axios from 'axios';
const imagesloaded = require('../../lib/js/imagesloaded/imagesloaded.pkgd.min.js');
const r = new Responsive();

module.exports = ()=>{
	/* ===============================================
	ajax colorbox
	=============================================== */
	$(document).bind('cbox_complete', function() {
		//$.colorbox.resize();
		// console.log('test');
	});
	$('.execColorBox').on('click',function(){
		let target = $(this).attr('href');
		let req = $(this).data('rendar');
		let token = $(this).data('token');

		let param = {
			inline:true,
			width:'100%',
			innerWidth:'100%',
			maxWidth:"950px",
			fixed:'true',
			href:target,
			opacity:0.8,
			onOpen: function(){
				$("#colorbox").css({'opacity':0}).addClass('open');
			},
			onComplete:function(){
				$.colorbox.resize();
				setTimeout(function(){
					$('#colorbox').animate({'opacity':1},600);
				},300);

			},
			onClosed:function(){
				$('#colorbox').css({'opacity':0}).removeClass('open');
			}
		};

		if(r.state()()){
			param.width = '88%%';
			param.innerWidth = '88%%';
			param.maxWidth = '88%%';
		}

		if($(target).find('.inner').length > 0){
			$.colorbox(param);
		}else{
			let tmp_str = require('./_colorbox_template.html');
			axios.get(req, {
				params: {
					token: token
				}
			})
			.then(function (response) {
				let compiled = _.template(tmp_str)(response.data);
				$(target).html(compiled);
				imagesloaded( target, function() {
					$.colorbox(param);
					FB.XFBML.parse();
				});
			})
			.then(function(response){
				window.parsePins();
			})
			.catch(function (error) {
				console.log(error);
			});
		}
	});
};



// WEBPACK FOOTER //
// ./js/scripts/AjaxColorbox.js